// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__5gBts","unreadBadge":"styles_unreadBadge__30s9A","modalContent":"styles_modalContent__SdzSL","modal":"styles_modal__2_-3W"};